import React from 'react';
import {injectIntl} from "react-intl";
import DailyPlanning from "../overview/DailyPlanning";
import {withAuthorization} from "../../../services/Authorization";

class PlanningOverview extends React.Component {

  render() {
    const {intl:{formatMessage}} = this.props;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'page.planning-overview'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <DailyPlanning/>
        </div>
      </div>
    )
  }
}

export default withAuthorization(injectIntl(PlanningOverview), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
